









































import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class ServiceRegisterAgreeTerms extends Vue {
  private bChecked: boolean = false;

  created () {
    this.$emit('getServiceTemp');
  }

  private nextStep (): void {
    if (!this.bChecked) {
      alert(this.toI18n('AGREE_ALERT_CHECK'));
      return;
    }

    this.$router.push('/service/registerForm?tempCode=' + this.$route.query.tempCode);
  }

  private toI18n (needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
